<div class="inventory-page">
  <div class="container-xxl inventory">
    <header class="inventory-head">
      <div>
        <h1>Inventario artistico</h1>
        <p>Le schede del catalogo artistico, raggruppate per categoria.</p>
      </div>
    </header>

    @if (inventoryArtistic.length > 0) {
      <p class="inventory-stats">
        <span><strong>{{ totalArticles }}</strong> {{ totalArticles === 1 ? 'scheda' : 'schede' }}</span>
        <span><strong>{{ inventoryArtistic.length }}</strong> {{ inventoryArtistic.length === 1 ? 'categoria' : 'categorie' }}</span>
      </p>

      <div class="inventory-groups">
        @for (group of inventoryArtistic; track group.title) {
          <section class="inventory-group">
            <button class="group-toggle" type="button" [disabled]="group.listArticles.length === 0"
              [attr.aria-expanded]="group.listArticles.length ? group.isOpen : null" (click)="toggleGroup(group)">
              <i class="bi" [class.bi-folder2-open]="group.isOpen" [class.bi-folder]="!group.isOpen" aria-hidden="true"></i>
              <span class="group-title">{{ group.title }}</span>
              <span class="group-count">{{ group.listArticles.length }}</span>
              @if (group.listArticles.length) {
                <i class="bi group-chevron" [class.bi-chevron-up]="group.isOpen" [class.bi-chevron-down]="!group.isOpen"
                  aria-hidden="true"></i>
              }
            </button>

            <div class="group-panel" [class.is-open]="group.isOpen" [attr.inert]="group.isOpen ? null : ''">
              <div class="group-panel-inner">
                @for (article of group.listArticles; track article.id) {
                  <button class="inventory-item" type="button" (click)="goToArticle(article.id)">
                    <span class="item-title">{{ article.title }}</span>
                  </button>
                }
              </div>
            </div>
          </section>
        }
      </div>
    } @else if (hasLoaded) {
      <p class="inventory-empty">Nessuna scheda in inventario.</p>
    }
  </div>
</div>
